/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

//Multiple options dropdown
//https://codepen.io/gatoledo1/pen/QWmpWjK

// This is done with this example
// https://codepen.io/alvarotrigo/pen/QWmZYJr

const optionMenu = document.querySelector(".select-menu");
let selectBtn = null;
let options = null;
let sBtn_text = null;

if(optionMenu){

  selectBtn = optionMenu.querySelector(".select-btn"),
  options = optionMenu.querySelectorAll(".option"),
  sBtn_text = optionMenu.querySelector(".sBtn-text");
}

if(selectBtn && optionMenu) {
  selectBtn.addEventListener("click", () =>
    optionMenu.classList.toggle("active")
  );
}
if(options) {
  options.forEach((option) => {
    option.addEventListener("click", () => {
      let selectedOption = option.querySelector(".option-text").innerText;
      sBtn_text.innerText = selectedOption;
  
      optionMenu.classList.remove("active");
    });
  });
}
